import { useEffect } from 'react';

const ENCHARGE_SCRIPT_ID = 'encharge-forms-script';

export default function EnchargeForm({ formId = 'd8d726cb-4b43-4393-839c-f1f8adcce798' }) {
  useEffect(() => {
    if (document.getElementById(ENCHARGE_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = ENCHARGE_SCRIPT_ID;
    script.type = 'text/javascript';
    script.className = 'encharge-form-embed-script';
    script.src = 'https://resources-app.encharge.io/embed-production.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return <div className="encharge-form-embed" data-encharge-form-id={formId} />;
}